import { useMemo } from 'react';
import type { FC, ReactNode } from 'react';
import { Tooltip as ChakraTooltip } from '@chakra-ui/react';
import type { TooltipProps as ChakraTooltipProps } from '@chakra-ui/react';
import { Text } from '../typography';
import { TooltipPlacement } from './types';

export interface TooltipProps {
    children: ReactNode;
    label: ReactNode;
    placement?: TooltipPlacement;
    variant?: ChakraTooltipProps['variant'];
}

export const Tooltip: FC<TooltipProps> = ({
    children,
    label,
    variant = 'new-style',
    placement = TooltipPlacement.bottom,
}) => {
    const content = useMemo(() => {
        if (typeof label === 'string') {
            return <Text size="small">{label}</Text>;
        }
        return label;
    }, [label]);

    return (
        <ChakraTooltip
            label={content}
            placement={placement}
            shouldWrapChildren
            padding="0.5rem"
            shadow="0px 2px 10px 0px rgba(65, 64, 66, 0.14)"
            hasArrow
            modifiers={[
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'viewport',
                    },
                },
            ]}
            arrowPadding={0}
            variant={variant}
        >
            {children}
        </ChakraTooltip>
    );
};

Tooltip.defaultProps = {
    variant: undefined,
    placement: undefined,
};
